import React from 'react';
import { Layout } from 'antd';

import './AccountContent.less';

type IAccountContentProps = {
  children?: React.ReactNode
}

export function AccountContent(props: IAccountContentProps) {
  return (
    <Layout.Content className="store-content">
      <Layout>
        {props.children}
      </Layout>
    </Layout.Content>
  );
}
